// extracted by mini-css-extract-plugin
export default {"group":"W8ksxRJEiK33faiRSe9Q","grp_no_border":"Q_sG47trFF1bVhL4Mg0N","dark":"dK3W2MnXOTTUHb7lPQdw","group_item":"jO2N7RoEmt0F7y_CrhwG"};